

























import {Component, Emit, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: 'BlueMenu'
})

export default class BlueMenu extends Vue {
  @Prop({ type: Array, default: (): any[] => ([]) }) private authTree!: any[];
  @Prop({ type: String, default: '1-1' }) private activeIndex?: string ;
  private isCollapse = false;

  @Emit('router-change')
  public routerChange(index: string): void {
    this.activeIndex = index;
    const auth = this.authTree.find((v: any) => {
      return JSON.stringify(v.id) === index.split('-')[0];
    });
    const auth2 =  auth.children.find((v2: any) => {
      return v2.id === index;
    });
    return auth2;
  }
}
